class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      if (!event.target.closest('filter-search')) { // Check if input is not from filter-search
        this.debouncedOnSubmit(event);
      }
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    FacetFiltersForm.updateCollectionTitle();
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.updateCollectionTitle();

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.updateCollectionTitle();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static updateCollectionTitle() {
    const urlParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev);
    const modelValues = urlParams.getAll('filter.p.m.is_hidden.model_dispozitiv');
    const brandValues = urlParams.getAll('filter.p.m.is_hidden.marca_dispozitiv');
    const vendorValue = urlParams.get('q');
    const container = document.getElementById('collection-title-extra');
    if(container) {
      container.innerHTML = "";

      if (brandValues.length === 1) {
        const brandValue = brandValues[0];
        if (modelValues.length === 1) {
          const modelValue = modelValues[0];
          container.innerHTML = (brandValue ? brandValue + " " : "") + modelValue;
        } else {
          container.innerHTML = brandValue ? brandValue : "";
        }
      } else if(brandValues.length === 0) {
        if (modelValues.length === 1) {
          const modelValue = modelValues[0];
          container.innerHTML +=  modelValue;
        }
      }

      let text = container.textContent.trim();
      if (text && !text.startsWith("\u2014")) {
        container.innerHTML = `<span class="dash-separator">\u00A0\u2014\u00A0</span>${text}`;
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    // Get the current URL params to check for marca and model
    const currentUrlParams = new URLSearchParams(window.location.search.slice(1));
    const marca = currentUrlParams.get('filter.p.m.is_hidden.marca_dispozitiv');
    const model = currentUrlParams.get('filter.p.m.is_hidden.model_dispozitiv');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));

      let finalParams = searchParams;
      if (marca) finalParams += `&filter.p.m.is_hidden.marca_dispozitiv=${encodeURIComponent(marca)}`;
      if (model) finalParams += `&filter.p.m.is_hidden.model_dispozitiv=${encodeURIComponent(model)}`;

      this.onSubmitForm(finalParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      let combinedParams = forms.join('&');

      // Append marca and model if they exist in the current URL
      if (marca) combinedParams += `&filter.p.m.is_hidden.marca_dispozitiv=${encodeURIComponent(marca)}`;
      if (model) combinedParams += `&filter.p.m.is_hidden.model_dispozitiv=${encodeURIComponent(model)}`;

      this.onSubmitForm(combinedParams, event);
    }
  }

  // onSubmitHandler(event) {
  //   event.preventDefault();
  //   const sortFilterForms = document.querySelectorAll('facet-filters-form form');
  //   if (event.srcElement.className == 'mobile-facets__checkbox') {
  //     const searchParams = this.createSearchParams(event.target.closest('form'));
  //     this.onSubmitForm(searchParams, event);
  //   } else {
  //     const forms = [];
  //     const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
  //
  //     sortFilterForms.forEach((form) => {
  //       if (!isMobile) {
  //         if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
  //           forms.push(this.createSearchParams(form));
  //         }
  //       } else if (form.id === 'FacetFiltersFormMobile') {
  //         forms.push(this.createSearchParams(form));
  //       }
  //     });
  //     console.log(forms.join('&'));
  //     this.onSubmitForm(forms.join('&'), event);
  //   }
  // }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    if (window.innerWidth <= 767) {
      this.minInput = this.querySelector('#Mobile-Filter-Price-GTE');
      this.maxInput = this.querySelector('#Mobile-Filter-Price-LTE');
      this.sliderElement = document.getElementById('price-slider-mobile');
    } else {
      this.minInput = this.querySelector('#Filter-Price-GTE');
      this.maxInput = this.querySelector('#Filter-Price-LTE');
      this.sliderElement = document.getElementById('price-slider');
    }

    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });


    if (this.minInput && this.maxInput && this.sliderElement) {
      this.initSlider();
      this.setMinAndMaxValues();
    }
  }

  parsePrice(priceStr) {
    return parseFloat(priceStr.replace(/[^0-9,.-]/g, '').replace('.', '').replace(',', '.'));
  }
  /**
   * Initialize the price slider using noUiSlider.
   */
  initSlider() {
    const minVal = this.parsePrice(this.minInput.getAttribute('data-min') || '0');
    const maxVal = this.parsePrice(this.maxInput.getAttribute('data-max') || '100');

    noUiSlider.create(this.sliderElement, {
      start: [minVal, maxVal],
      connect: true,
      range: {
        min: minVal,
        max: maxVal,
      },
    });

    this.sliderElement.noUiSlider.on('update', (values, handle) => {
      const value = parseFloat(values[handle]).toFixed(2).replace('.', ','); // Convert back to localized format
      if (handle === 0) {
        this.minInput.value = value;
      } else {
        this.maxInput.value = value;
      }
    });

    this.sliderElement.noUiSlider.on('change', () => {
      const minValue = parseFloat(this.sliderElement.noUiSlider.get()[0]).toFixed(2).replace('.', ',');
      const maxValue = parseFloat(this.sliderElement.noUiSlider.get()[1]).toFixed(2).replace('.', ',');

      this.minInput.value = minValue;
      this.maxInput.value = maxValue;

      this.minInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    this.minInput.addEventListener('change', () => {
      this.sliderElement.noUiSlider.set([this.parsePrice(this.minInput.value), null]);
    });

    this.maxInput.addEventListener('change', () => {
      this.sliderElement.noUiSlider.set([null, this.parsePrice(this.maxInput.value)]);
    });
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const minVal = this.parsePrice(this.minInput.getAttribute('data-min') || '0');
    const maxVal = this.parsePrice(this.maxInput.getAttribute('data-max') || '100');

    this.maxInput.setAttribute('data-min', minVal);
    this.minInput.setAttribute('data-max', maxVal);
  }

  adjustToValidValues(input) {
    const value = this.parsePrice(input.value);
    const min = this.parsePrice(input.getAttribute('data-min'));
    const max = this.parsePrice(input.getAttribute('data-max'));

    if (value < min) input.value = min.toFixed(2).replace('.', ',');
    if (value > max) input.value = max.toFixed(2).replace('.', ',');
  }
}


customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FilterSearch extends HTMLElement {
  constructor() {
    super();

    this.attachEvents();
  }

  attachEvents() {
    document.addEventListener('DOMContentLoaded', () => {
      const searchInput = this.querySelector('#filterSearch');
      if (searchInput) {
        searchInput.addEventListener('input', this.filterOptions.bind(this));
      }
    });
  }

  filterOptions() {
    var searchTerm = this.querySelector('#filterSearch').value;
    const parentDisplay = this.nextElementSibling;
    let filterItems = [];

    if (parentDisplay && parentDisplay.classList.contains('parent-display')) {
      filterItems = parentDisplay.querySelectorAll('.list-menu__item');
    }

    if (searchTerm === '') {
      if (filterItems) {
        filterItems.forEach((item) => {
          item.style.display = 'block';
          if(item.classList.contains("show-more-item")){
            item.classList.add("hidden");
          }
        });
      }
    } else {
      searchTerm = searchTerm.toLowerCase();

      if (filterItems) {

        filterItems.forEach((item) => {
          const text = item.querySelector('input').value.trim().toLowerCase();
          if (text.includes(searchTerm)) {
            item.classList.remove("hidden");
            item.style.display = 'block';
          } else {
            item.style.display = 'none';
          }
        });
      } else {
        console.warn('Parent display element not found.');
      }
    }
  }
}

customElements.define('filter-search', FilterSearch);





